import { ReactNode } from "react";

import PageWrapper from "components/PageWrapper";
import PageInfoHeader from "ds/components/PageInfoHeader";

type FlowsSettingsPageLayoutProps = {
  children: ReactNode;
};

const FlowsSettingsPageLayout = ({ children }: FlowsSettingsPageLayoutProps) => {
  return (
    <>
      <PageInfoHeader title="Flows" />
      <PageWrapper>{children}</PageWrapper>
    </>
  );
};

export default FlowsSettingsPageLayout;
